import { render, staticRenderFns } from "./CargoExpenseList.vue?vue&type=template&id=c2659d5e&scoped=true"
import script from "./CargoExpenseList.vue?vue&type=script&lang=js"
export * from "./CargoExpenseList.vue?vue&type=script&lang=js"
import style0 from "./CargoExpenseList.vue?vue&type=style&index=0&id=c2659d5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2659d5e",
  null
  
)

export default component.exports